import { TableProps } from "@/ui/tables/Table";
import { Button } from "@chakra-ui/react";
import TruncateText from "@/utils/TruncateText";
import { ActivityLabel } from "@/shared/core-activity-labels";

export const ActivityLabelsTableColumns = (
  handleToggleEnabled: (activityLabel: ActivityLabel) => void,
): TableProps<ActivityLabel>["headers"] => {
  return [
    {
      label: "Nombre",
      itemLabel: (item: ActivityLabel) => (
        <TruncateText maxWidth={200}>{item.label}</TruncateText>
      ),
      sortable: true,
      sortKey: "label",
    },

    {
      label: "Estado",
      itemLabel: (item: ActivityLabel) => (
        <Button
          variant="ghost"
          size="sm"
          colorPalette={item.enabled ? "gray" : "green"}
          color={item.enabled ? "fg.muted" : undefined}
          onClick={() => handleToggleEnabled(item)}
          disabled={item.zones && item.zones.length > 1}
        >
          {item.enabled ? "Deshabilitar" : "Habilitar"}
        </Button>
      ),
    },
  ];
};
